import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=2db47530"
import script from "./ResetPassword.vue?vue&type=script&lang=js"
export * from "./ResetPassword.vue?vue&type=script&lang=js"
import style0 from "./ResetPassword.vue?vue&type=style&index=0&id=2db47530&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports